export default __webpack_public_path__ + "static/media/blockchain.75e32944.svg";